export const compareWords = (word1, word2) => {
  return word1.toLowerCase()===word2.toLowerCase()
}



// WEBPACK FOOTER //
// ./src/helper.js